'use strict';

var React = require('react/addons');
var classSet = React.addons.classSet;

/* Stores */
var LanguageStore = require('stores/language');

/* Components */
var TitledGroup = require('./titled-group');

var TextArea = React.createClass({
  displayName: 'TextArea',

  getInitialState: function getInitialState() {
    return {
      value: this.props.children || this.props.value || ''
    };
  },

  componentDidMount: function componentDidMount() {
    this.value = this.state.value;
  },

  focus: function focus() {
    this.refs.text.getDOMNode().focus();
  },

  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    var component = this;

    if (prevProps.value !== component.props.value) {
      component.setState({ value: component.props.value || '' });
      component.value = component.props.value;
    }
  },

  render: function render() {
    var component = this;

    var props = this.props;
    var state = this.state;
    var invalid = props.invalid;
    var translationKey = props.translationKey;

    var descriptionTranslationKey = translationKey + '_field_description';
    var placeholderTranslationKey = translationKey + '_field_placeholder';
    var errorMessageTranslationKey = props.errorKey || translationKey + '_field_invalid';

    var showDescriptionAlways = props.showDescription === 'always';
    var value = component.state.value;
    var hasValue = value !== undefined && value.length > 0;
    var translate = LanguageStore.translate;
    var descriptionText = state.focus || hasValue || showDescriptionAlways ? props.description !== undefined ? props.description : translate(descriptionTranslationKey) : ' ';
    var placeholderText = state.focus ? null : props.placeholder || translate(placeholderTranslationKey);
    var errorMessageText = translate(errorMessageTranslationKey);

    var descriptionNode = null;
    var errorMessageNode = null;
    var title = null;

    if (invalid) {
      title = errorMessageText;
    } else if (state.focus || hasValue || showDescriptionAlways) {
      title = descriptionText;
    }

    var classes = { 'text-area': true };
    var inputClasses = {};

    inputClasses.invalid = invalid;
    classes.invalid = invalid;
    classes[props.className] = true;
    classes['focus'] = state.focus;

    return React.createElement(
      TitledGroup,
      { className: classSet(classes), title: title },
      React.createElement('textarea', {
        ref: 'text',
        className: classSet(inputClasses),
        value: value,
        placeholder: placeholderText,
        onChange: component._onChange,
        onFocus: component._onFocus,
        onBlur: component._onBlur,
        disabled: props.disabled })
    );
  },

  _onChange: function _onChange(evt) {
    var value = evt.target.value;

    this.value = value;
    this.setState({ value: value });

    if (this.props.onChange) {
      this.props.onChange(evt);
    }
  },

  _onFocus: function _onFocus() {
    this.setState({ focus: true });
  },

  _onBlur: function _onBlur() {
    this.setState({ focus: false });
  }

});

module.exports = TextArea;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/ui/text-area.js
 **/